import React from 'react';
import { AIcon } from '@marriott/mi-web-ui-kit';
import * as Styled from './MPropertyLocationSummary.styles';

export interface LocationSummary {
  city?: string;
  state?: string;
  country?: string;
}

export interface MPropertyLocationSummaryProps {
  locationSummary?: LocationSummary;
  showLocationIcon?: boolean;
}

export const MPropertyLocationSummary: React.FC<MPropertyLocationSummaryProps> = ({
  locationSummary,
  showLocationIcon = false,
}) => {
  if (!locationSummary || (!locationSummary.city && !locationSummary.state && !locationSummary.country)) {
    return null;
  }

  // Build location parts: City, State, Country (exclude USA)
  const country = locationSummary.country?.toUpperCase() === 'US' ? null : locationSummary.country;
  const parts = [locationSummary.city, locationSummary.state, country].filter(Boolean);
  const locationText = parts.join(', ');

  return (
    <Styled.LocationContainer>
      {showLocationIcon ? (
        <Styled.LocationIcon aria-hidden="true">
          <AIcon icon="icon-location" iconClass="icon-alt" />
        </Styled.LocationIcon>
      ) : (
        <Styled.Separator className="t-font-xs" aria-hidden="true">
          •
        </Styled.Separator>
      )}
      <span>{locationText}</span>
    </Styled.LocationContainer>
  );
};
